import React from 'react'
import { SetPaddingProps } from '../../utils/PaddingContext'
import { useIsMobile } from '../../utils/helpers'
import TestimonialsMobile from './TestimonialsMobile'
import TestimonialsDesktop from './TestimonialsDesktop'

const data = [
    {
        name: 'Dr. Stefan Seemayer',
        position: 'Global Scientific Discipline Lead - Protein Engineering',
        company: 'BASF',
        quote:
      'I very much enjoyed collaborating with Biomatter. Apart from getting the chance to apply their exciting technology to some of our use cases, the interactions have always been incredibly pleasant, professional, and effective.',
        picture: 'stefan-seemayer',
        pictureClasses: 'rounded-full w-1/2',
    },
    {
        name: 'Dr. Arvydas Lubys',
        position: 'Sr. Director, Research and Development',
        company: 'Thermo Fisher Scientific',
        quote:
      'Biomatter has proven to be a trustworthy and reliable enzyme design partner - professional, flexible and attentive to our business needs.',
        picture: 'arvydas-lubys',
        pictureClasses: 'rounded-full w-1/2 aspect-square',
    },
    {
        company: 'Kirin Holdings Company, Limited',
        quote:
      'Biomatter has achieved excellent project results and we are incredibly happy with our partnership. Intelligent Architecture™ platform is a big step forward for protein design.',
        picture: 'kirin',
        pictureClasses: 'w-1/2',
    },
]

const Testimonials = ({ setPadding }: SetPaddingProps) => {
    const isMobile = useIsMobile()
    return isMobile ? (
        <TestimonialsMobile data={data} setPadding={setPadding} />
    ) : (
        <TestimonialsDesktop setPadding={setPadding} data={data} />
    )
}

export default Testimonials
